import type { Tariff, TariffGroup } from '@src/core/buyerApiClient';

export function resolveDefaultTariffFromGroup(tariffGroup: TariffGroup | null | undefined): Tariff | null {
  if (!tariffGroup?.tariffs?.length) {
    return null;
  }

  return tariffGroup.tariffs.find((tariff) => tariff.isDefault) ?? null;
}
